import { Icon, IconType, Loading } from "~/modules/Common/Icons";

const iconTypes: Record<string, IconType> = {
  google: "google",
  apple: "apple",
  metamask: "Chains-METAMASK",
};

type TProps = {
  type: "google" | "apple" | "metamask";
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
};

export function CircularLoginButton({
  type,
  onClick,
  isLoading,
  disabled,
}: TProps) {
  return (
    <button
      className="flex-center h-12 w-12 rounded-full bg-ciety-wh disabled:bg-ciety-dk-80"
      onClick={onClick}
      disabled={disabled}
    >
      {isLoading ? (
        <Loading className="h-6 w-6 animate-spin" />
      ) : (
        <Icon iconType={iconTypes[type]} />
      )}
    </button>
  );
}
